<template>
  <div class="prescription">
    <el-row>
      <el-col :span="8">
        <label>咨询单号：</label>
        <span>{{ prescriptionDetail.advisoryId || '-' }}</span>
      </el-col>
      <el-col :span="8">
        <label>费用类型：</label>
        <span>{{ prescriptionDetail.costTypeString || '-' }}</span>
      </el-col>
      <el-col :span="8">
        <label>医保费别：</label>
        <span>{{ prescriptionDetail.insureMedTypeString || '-' }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <label>处方编号：</label>
        <span v-if="prescriptionDetail.doctorAuditStatus === 0">--</span>
        <span v-else>{{ prescriptionDetail.id }}</span>
      </el-col>
      <el-col :span="8">
        <label>状态：</label>
        <span>{{ prescriptionDetail.prescriptionTotalStatus | parsePrescriptionStatus }}</span>
      </el-col>
      <el-col :span="8">
        <label>提交时间：</label>
        <span>{{ prescriptionDetail.orderTimeStr }}</span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <label>处方医生：</label>
        <span>{{ prescriptionDetail.doctorName }}</span>

        <span
          v-if="prescriptionDetail.doctorAptitudeButtonInfo && prescriptionDetail.doctorAptitudeButtonInfo.showStatus"
          style="margin-left: 17px; color: #1e8dff; font-size: 14px; cursor: pointer"
          @click="watchCert"
        >
          查看资质
        </span>
      </el-col>
      <el-col :span="8">
        <label>医生医保编码：</label>
        <span>{{ prescriptionDetail.doctorCode }}</span>
        <span
          v-if="prescriptionDetail.doctorCode"
          class="copy"
          v-clipboard:copy="prescriptionDetail.doctorCode"
          v-clipboard:success="clipboardSuccess"
        >
          复制
        </span>
      </el-col>
      <el-col :span="8">
        <label>医生职称：</label>
        <span>{{ prescriptionDetail.doctorTitle }}</span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <label>第一执业机构：</label>
        <span>{{ prescriptionDetail.doctorHospitalName }}</span>
      </el-col>
      <el-col :span="8">
        <label>互联网医院：</label>
        <span>{{ prescriptionDetail.internetHospitalName }}</span>
      </el-col>
      <el-col :span="8">
        <label>科别：</label>
        <span>{{ prescriptionDetail.dept }}</span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <label>医院药师：</label>
        <span>{{ prescriptionDetail.pharmacistAuditName || '-' }}</span>
      </el-col>
      <el-col :span="8">
        <label>医院药师编码：</label>
        <span>{{ prescriptionDetail.prePharmacistMedicalCode || '-' }}</span>
      </el-col>
      <el-col :span="8">
        <label>医院药师ID：</label>
        <span>{{ prescriptionDetail.pharmacistAuditId }}</span>
      </el-col>
    </el-row>
    <el-drawer
      custom-class="prescription-detail-drawer"
      title="医生资质信息"
      direction="rtl"
      :visible.sync="drawerVisible"
      @open="fetchCert"
    >
      <div class="certification-wrapper">
        <div class="certification-section">
          <div class="title">基本信息</div>
          <div class="row">
            <span>医生姓名：</span>
            <span>{{ doctorCert.doctorName }}</span>
          </div>
          <div class="row">
            <span>医生执业证编号：</span>
            <span>{{ doctorCert.practiceCode }}</span>
            <span class="copy" v-clipboard:copy="doctorCert.practiceCode" v-clipboard:success="clipboardSuccess">
              复制
            </span>
          </div>
        </div>
        <div class="certification-section" v-if="doctorCert.practiceUrl">
          <div class="title">医生执业证</div>
          <div class="row">
            <ds-image
              class="image"
              :src="src"
              v-for="(src, i) in doctorCert.practiceUrl"
              :preview-src-list="doctorCert.practiceUrl"
              :key="i"
              :preview-index="i"
              fit="cover"
            ></ds-image>
          </div>
        </div>
        <div class="certification-section" v-if="doctorCert.professionUrl">
          <div class="title">医生资格证</div>
          <div class="row">
            <ds-image
              class="image"
              :src="src"
              v-for="(src, i) in doctorCert.professionUrl"
              :preview-src-list="doctorCert.professionUrl"
              :key="i"
              :preview-index="i"
              fit="cover"
            ></ds-image>
          </div>
        </div>
        <div class="certification-section" v-if="doctorCert.jobTitleUrl">
          <div class="title">医生职称证</div>
          <div class="row">
            <ds-image
              class="image"
              :src="src"
              v-for="(src, i) in doctorCert.jobTitleUrl"
              :preview-src-list="doctorCert.jobTitleUrl"
              :key="i"
              :preview-index="i"
              fit="cover"
            ></ds-image>
          </div>
        </div>
        <div class="certification-section" v-if="doctorCert.idCardUrl">
          <div class="title">医生身份证</div>
          <div class="row">
            <ds-image
              class="image"
              :src="src"
              v-for="(src, i) in doctorCert.idCardUrl"
              :preview-src-list="doctorCert.idCardUrl"
              :key="i"
              :preview-index="i"
              fit="cover"
            ></ds-image>
          </div>
        </div>
        <div class="certification-section">
          <div class="title">医生刷脸记录</div>
          <div class="row">
            <ds-image
              class="image certification-section-image"
              v-for="(item, i) in doctorCert.faceRecognitionRecord"
              :src="item.faceRecognitionUrl"
              :preview-src-list="doctorCert.faceRecognitionRecord.map(el => el.faceRecognitionUrl)"
              :key="i"
              :preview-index="i"
              fit="contain"
              :item="item"
            >
              <template #text="data">
                <div style="text-align: center; margin-top: 10px">
                  {{ data.item.recTime | timeFormat }}
                </div>
              </template>
            </ds-image>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import agreement from '@/components/agreement';
import Image from '@/components/Image';
import dayjs from 'dayjs';

export default {
  name: 'prescriptionDesc',
  components: {
    'ds-image': Image
  },
  props: {
    prescriptionDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      drawerVisible: false,
      doctorCert: {}
    };
  },
  filters: {
    timeFormat(t) {
      if (t) {
        return dayjs(t).format('YYYY.M.D HH:mm:ss');
      }
    }
  },
  methods: {
    watchCert() {
      if (this.prescriptionDetail?.doctorAptitudeButtonInfo?.agreementStatus) {
        this.drawerVisible = true;
      } else {
        const submit = () =>
          Fetch.signAgreement4DoctorCert(this.prescriptionDetail.doctorAptitudeButtonInfo?.agreementId).then(() => {
            this.drawerVisible = true;
            this.$emit('refreshDetail');
          });
        agreement.show({
          props: { submit, src: `${Util.getItmOrigin()}project/agreement-drugstore#/doctorCert` }
        });
      }
    },
    fetchCert() {
      const { id: prescriptionId, doctorId } = this.prescriptionDetail;
      Fetch.getDoctorAptitudeInfo({ prescriptionId, doctorId }).then(res => {
        this.doctorCert = res;
      });
    },
    clipboardSuccess() {
      this.$message.success('复制成功！');
    }
  }
};
</script>

<style lang="scss">
.prescription-detail-drawer {
  width: 496px !important;

  .el-drawer__header {
    padding: 20px;
    margin-bottom: unset;
    border-bottom: 1px solid #eee;

    span {
      color: #262626;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .el-drawer__body {
    overflow: auto;
  }

  .certification-wrapper {
    padding: 24px;
    box-sizing: border-box;

    .certification-section {
      margin-bottom: 20px;

      .title {
        position: relative;
        padding-left: 10px;
        margin-bottom: 14px;
        font-size: 16px;
        font-weight: 600;
        box-sizing: border-box;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 2px;
          height: 14px;
          background-color: #1e8dff;
          transform: translateY(-50%);
        }
      }

      .row {
        margin-bottom: 12px;

        > span {
          color: #262626;
          font-size: 12px;
        }

        .image {
          width: 80px;
          height: 80px;
          border-radius: 4px;
          margin-right: 8px;
        }
        .certification-section-image {
          overflow: visible !important;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.copy {
  margin-left: 8px;
  color: #2386eb;
  cursor: pointer;
}
</style>
